/**
 * name 媒体实验室
 * author zhang.yingyu
 * createTime 2019-04-01
 **/
"use strict";
angular.module("mediaLaboratoryModule",[
    "addKeywordTipModule",//增加关键词指令
    "hotCalendarModule",//热度日历
    "mediaLaboratoryRouterModule",//媒体实验室路由
    "mediaLaboratoryLeftModule",//媒体实验室左侧菜单栏
    "hotPointRelateModule",//热点关联
    "keyRecommendModule",//线索推荐
    "timeAxisModule",//时间轴梳理
    "hotPointAtlasModule",//热点图谱
    "timeAxisDetailModule",//时间轴详情
    "hotPointScatterChartModule",//热点散点图
    "hotAtlasRelationChartModule",//热点图谱关系图
    "mediaLaboratoryServiceModule",//媒体实验室服务
])
.controller("mediaLaboratoryCtrl",[function(){

}]);